import createCachedSelector from 're-reselect'

import { selectIsPreviousPeriodAvailable } from 'ducks/reports/controls'

import gaugeCacheKey from './cacheKeys/gaugeCacheKey'
import selectDecoratedGauge from './selectDecoratedGauge'

export default createCachedSelector(
  state => state,
  (state, props) => props,
  (state, { includePrevious }) =>
    !!includePrevious && selectIsPreviousPeriodAvailable(state),
  (state, props, includePrevious) => {
    const { gauges, join: { through: joinThrough } = {} } = props
    function isJoinedThroughGauge({ id }) {
      return id && joinThrough === id
    }
    const joinedThroughGauge = gauges.find(isJoinedThroughGauge)
    if (!joinedThroughGauge) return null
    return selectDecoratedGauge(state, {
      ...props,
      includePrevious,
      isJoinedThrough: true,
      gauge: joinedThroughGauge,
    })
  }
)(gaugeCacheKey)
